import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const PdfViewerContainer = ({
  pdfUrl,
  backRoute = "/Fill_My_Form",
  title = "PDF Preview",
}) => {
  const navigate = useNavigate();

  useEffect(() => {
    return () => {
      if (pdfUrl?.startsWith("blob:")) {
        URL.revokeObjectURL(pdfUrl);
      }
    };
  }, [pdfUrl]);

  const handleBack = () => {
    navigate(backRoute);
  };

  const handlePrint = () => {
    const iframe = document.getElementById("pdf-preview-frame");

    if (!iframe) {
      return;
    }

    try {
      iframe.contentWindow?.focus();
      iframe.contentWindow?.print();
    } catch (error) {
      console.error("Unable to print PDF:", error);

      window.open(pdfUrl, "_blank", "noopener,noreferrer");
    }
  };

  if (!pdfUrl) {
    return (
      <div className="flex min-h-[70vh] items-center justify-center">
        <p className="text-gray-600 dark:text-gray-300">
          PDF is not available.
        </p>
      </div>
    );
  }

  return (
    <div className="flex min-h-[calc(100vh-120px)] flex-col bg-gray-100 p-3 dark:bg-zinc-950 sm:p-5">
      <div className="mx-auto flex w-full max-w-7xl flex-1 flex-col overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-xl dark:border-zinc-700 dark:bg-zinc-900">
        <div className="flex flex-col gap-3 border-b border-gray-200 px-4 py-3 dark:border-zinc-700 sm:flex-row sm:items-center sm:justify-between">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
            {title}
          </h2>

          <div className="flex flex-wrap gap-2">
            <button
              type="button"
              onClick={handleBack}
              className="btn-gradient rounded-lg px-5 py-2.5 text-sm font-semibold text-white shadow-md transition hover:scale-[1.02]"
            >
              ← Back to Form
            </button>

            <button
              type="button"
              onClick={handlePrint}
              className="btn-gradient rounded-lg px-5 py-2.5 text-sm font-semibold text-white shadow-md transition hover:scale-[1.02]"
            >
              🖨 Print
            </button>
          </div>
        </div>

        <div className="min-h-[650px] flex-1 bg-gray-200 dark:bg-zinc-800">
          <iframe
            id="pdf-preview-frame"
            src={pdfUrl}
            title={title}
            className="h-full min-h-[650px] w-full border-0"
          />
        </div>
      </div>
    </div>
  );
};

export default PdfViewerContainer;

